// Every Next Steps localStorage key the courses store writes shares this prefix:
// the per-view notes and highlight read-caches, the tag list, the reader view,
// and the blank-answer map (src/store/modules/courses.js). They are a member's
// own words, so signing out removes all of them; before this only the token
// went, and the next member on a shared phone inherited the lot.
// docs/plans/2026-09-02-next-steps-e2e-encryption.md, decision 37.
export const NEXT_STEPS_STORAGE_PREFIX = 'next-steps-';

// NOT swept here, on purpose: `courses-e2ee-banner:<id>`
// (utils/courses-encryption/encryption-banner.js). It looks like it belongs in
// this list — it is a Next Steps key on a shared phone — and it does not, for
// three reasons, in order of how much they matter:
//
//  1. It is a tombstone, not a cache. `seen` IS the guard `markBannerPending`
//     reads before re-arming the banner, so clearing it at sign-out would
//     re-announce "from today, what you write here is encrypted" to a member
//     who re-enrols after "Start over" — the exact bug #1587 fixed, under a
//     narrower repro.
//  2. This sweeper's job is a member's own WORDS (see above). The value here is
//     a two-state enum, `pending` or `seen`, written by the app.
//  3. The privacy it would buy is already spent, deliberately. Sign-out keeps
//     the platform copy of the member's wrapped master key under the same
//     member id (mixins/Logout.js, spec section 6.8: "it belongs to the phone's
//     owner, like a saved password"), so removing the enum while that stays
//     hides nothing from anyone.
//
// If the marker ever does have to go, the place for it is "Start over" or
// account erasure — where the key material goes too — not sign-out.

/**
 * Remove every Next Steps key from localStorage.
 * @returns {string[]} the keys removed; empty when storage is unavailable.
 */
export function clearNextStepsCaches() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(NEXT_STEPS_STORAGE_PREFIX)) keys.push(key);
    }
    keys.forEach(key => localStorage.removeItem(key));
    return keys;
  } catch (e) {
    console.warn('[NextStepsStorage] Failed to clear localStorage:', e);
    return [];
  }
}
